import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useEffect, useState } from 'react';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import classNames from 'classnames';
import { tuple } from '../_utils/type';
import devwarning from '../_utils/devwarning';
export var IconPositionTypes = tuple('left', 'right');
var InternalCollapse = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    prefixCls = _React$useContext.prefixCls,
    userDefaultProps = _React$useContext.compDefaultProps;
  var _getCompProps = getCompProps('Collapse', userDefaultProps, props),
    accordion = _getCompProps.accordion,
    activeKey = _getCompProps.activeKey,
    bordered = _getCompProps.bordered,
    defaultActiveKey = _getCompProps.defaultActiveKey,
    expandIcon = _getCompProps.expandIcon,
    expandIconPosition = _getCompProps.expandIconPosition,
    onChange = _getCompProps.onChange,
    style = _getCompProps.style,
    className = _getCompProps.className,
    children = _getCompProps.children,
    customPrefixcls = _getCompProps.prefixCls;
  var CollapsePrefixCls = getPrefixCls(prefixCls, 'collapse', customPrefixcls); // 样式前缀
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    innerKey = _useState2[0],
    setInnerKey = _useState2[1];
  var convertActiveKey = function convertActiveKey(newKey) {
    var ret = [];
    if (Array.isArray(newKey)) {
      ret = newKey;
    } else if (typeof newKey === 'string' || typeof newKey === 'number') {
      ret = [newKey];
    }
    if (accordion && ret.length) {
      ret = [ret[0]];
    }
    return ret;
  };
  useEffect(function () {
    if (typeof activeKey !== 'undefined') {
      setInnerKey(convertActiveKey(activeKey));
    }
  }, [activeKey]);
  useEffect(function () {
    if (typeof activeKey !== 'undefined' || typeof defaultActiveKey !== 'undefined') {
      setInnerKey(convertActiveKey(typeof activeKey !== 'undefined' ? activeKey : defaultActiveKey));
    }
  }, []);
  var onPanelChange = function onPanelChange(key) {
    var newKey = [];
    if (accordion) {
      if (_includesInstanceProperty(innerKey).call(innerKey, key)) {
        newKey = [];
      } else {
        newKey = [key];
      }
    } else {
      if (_includesInstanceProperty(innerKey).call(innerKey, key)) {
        newKey = _filterInstanceProperty(innerKey).call(innerKey, function (d) {
          return d !== key;
        });
      } else {
        var _context;
        newKey = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(innerKey), [key]);
      }
    }
    if (typeof activeKey === 'undefined') {
      setInnerKey(newKey);
    }
    onChange && onChange(newKey);
  };
  var renderPanel = function renderPanel() {
    var _context2;
    return _mapInstanceProperty(_context2 = React.Children).call(_context2, children, function (item) {
      var _a;
      if (((_a = item === null || item === void 0 ? void 0 : item.type) === null || _a === void 0 ? void 0 : _a.displayName) !== 'Panel') {
        devwarning(true, 'Collapse', 'children必须为Collapse.Panel');
        return item;
      }
      return /*#__PURE__*/React.cloneElement(item, _extends({
        expandIcon: expandIcon,
        expandIconPosition: expandIconPosition,
        onChange: onPanelChange,
        bordered: bordered,
        innerKey: innerKey
      }, item.props));
    });
  };
  var rootClassName = classNames(className, _defineProperty({}, "".concat(CollapsePrefixCls), true));
  var collapseRef = ref || /*#__PURE__*/React.createRef();
  return /*#__PURE__*/React.createElement("div", {
    className: rootClassName,
    style: style,
    ref: collapseRef
  }, renderPanel());
});
InternalCollapse.displayName = 'Collapse';
export default InternalCollapse;